import { useContext, useMemo } from 'react'

import { GCM_PASSENGER_INFO, SET_ENABLE_GET_COST } from '../Constants'
import Input from '../micros/Input'

export default ({
	itineraryInfo,
	labelText,
	isLoggedIn,
	disabled,
	context,
	contextKey,
	type = GCM_PASSENGER_INFO,
	...rest
}) => {
	const [state, dispatch] = useContext(context)

	const entryPoint = useMemo(() => state[contextKey], [state, contextKey])
	const onChange = value => {
		dispatch({
			type,
			payload: {
				...entryPoint,
				name: value,
			},
		})
		itineraryInfo &&
			isLoggedIn &&
			dispatch({
				type: SET_ENABLE_GET_COST,
				payload: {
					itineraryInfo,
					isLoggedIn,
				},
			})
	}

	return (
		<Input
			placeholder={labelText}
			onChange={onChange}
			value={entryPoint?.name}
			disabled={disabled}
			{...rest}
		/>
	)
}
